import { useTranslations } from 'next-intl'

import Flex from '@/components/atoms/Flex'
import { Paragraph } from '@/components/atoms/Typography'

const Areas = ({ items }: { items: string[] }) => {
  const t = useTranslations('General')
  const and = t('and')
  const comma = ','

  const areasText = items.reduce((acc, curr, index) => {
    if (index === items.length - 1 && items.length > 1) {
      return `${acc} ${and} ${curr}`
    }
    return `${!acc ? '' : `${acc}${comma} `} ${curr}`
  }, '')

  return (
    <Flex
      wrap
      gap={'4px'}
    >
      <Paragraph
        size='xs'
        weight='bold'
      >
        {t('area')}:
      </Paragraph>
      <Paragraph size='xs'>{areasText}</Paragraph>
    </Flex>
  )
}
export default Areas
